import { call, put, takeLatest } from 'redux-saga/effects'
import { api } from '~/services/api'
import {
  getProfileInfoSuccess,
  getProfileInfoFailed,
  GET_PROFILE_INFO_START,
} from '../../actions/profile'

/**
 * get profile api
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */
const getProfileInfoApi = (props) => {
  var uri = `/admin/auth/info`
  return api.get(uri, props)
}

/**
 * [Worker]
 * Handle get data request and response
 * @param {object} action
 */
function* doGetProfileInfo(action) {
  try {
    const response = yield call(getProfileInfoApi, action?.payload)
      yield put(getProfileInfoSuccess(response))

      // Call callback action if provided
      if (action.onSuccess) {
        yield action.onSuccess(response)
      }
  } catch (error) {
    yield put(getProfileInfoFailed())
    // Call callback action if provided

    if (action.onError) {
      yield action.onError(error)
    }
  }
}

/**
 * [Watcher]
 * Watch get profile
 */
export default function* watchGetProfileInfo() {
  yield takeLatest(GET_PROFILE_INFO_START, doGetProfileInfo)
}
